import { ORDER_TYPE_DIRECT_SALE } from '../Utils/Constants/Service';
import BaseService from './BaseService';

export interface CreateProps {
  store_id: number;
  order_type: number;
  store_table_id: number | null;
}

export interface ShowProps {
  cart_id: number;
  store_id: number;
  order_type: number;
}

export interface StepsAndComplementsProps {
  store_id: number;
  product_id: number;
  order_type: number;
}

export interface GuestProps {
  store_id: number;
  order_type: number;
}

export interface GuestCartProps {
  store_id: number;
  order_type_id: number;
  order_type: string;
}

export interface RemoveAllProps {
  order_type: number;
}

export interface CouponProps {
  coupon_code: string;
  order_type: number;
  store_id: number;
}

export interface ChangeQuantityProps {
  id: number;
  order_type: number;
  quantity: number;
}

export interface DeleteProductFromCartProps {
  id: number;
  order_type: number;
}

export interface UpdateCartTableProps {
  cart_id: number;
  order_type: number;
  store_id: number;
  store_table_id: number;
}

export interface AddProductProps {}

export default class CartService {
  baseService: BaseService;

  constructor(orderType: string, token?: string, guestToken?: string) {
    this.baseService = new BaseService(orderType, token, guestToken);
  }

  async create(payload: CreateProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ payload: CreateProps }>('cart/create', payload);
      return response.data;
    } catch (error) {
      console.error('Erro create:', error);
      throw error;
    }
  }

  async addProduct(cartId: number, payload: AddProductProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ payload: AddProductProps }>(`cart/${cartId}/add`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro addProduct:', error);
      throw error;
    }
  }

  async show(params: ShowProps): Promise<any> {
    try {
      const response = await this.baseService.http.get<{ params: ShowProps }>(`cart/${params.cart_id}/show?store_id=${params.store_id}&order_type=${params.order_type}`);

      return response.data;
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  }

  async stepsAndComplements(params: StepsAndComplementsProps): Promise<any> {
    try {
      const response = await this.baseService.http.get<{ params: StepsAndComplementsProps }>(`products/composite/steps?store_id=${params.store_id}&product_id=${params.product_id}&order_type=${params.order_type}`);
      return response.data;
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  }

  async guestToken(payload: GuestProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ payload: GuestProps }>(`cart/guest`, payload);
      return response.data;
    } catch (error) {
      console.error('guestToken:', error);
      throw error;
    }
  }

  async createGuestCart(params: GuestCartProps): Promise<any> {
    try {
      const isDirectSale = params.order_type === ORDER_TYPE_DIRECT_SALE ? '&is_direct_sale=true' : '';
      const response = await this.baseService.http.get<{ params: GuestCartProps }>(`cart?store_id=${params.store_id}&order_type=${params.order_type_id}${isDirectSale}`);
      return response.data;
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  }

  async removeAll(cart_id: number, payload: RemoveAllProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ payload: RemoveAllProps }>(`cart/${cart_id}/remove-all`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro removeAll:', error);
      throw error;
    }
  }

  async applyCoupon(cart_id: number, payload: CouponProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ payload: CouponProps }>(`cart/${cart_id}/apply-coupon`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro applyCoupon:', error);
      throw error;
    }
  }

  async removeCoupon(cart_id: number, payload: CouponProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ payload: CouponProps }>(`cart/${cart_id}/remove-coupon`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro removeCoupon:', error);
      throw error;
    }
  }
  
  async changeQuantity(cart_id: number, payload: ChangeQuantityProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ payload: ChangeQuantityProps }>(`cart/${cart_id}/change-quantity`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro changeQuantity:', error);
      throw error;
    }
  }
  
  async deleteProductFromCart(cart_id: number, payload: DeleteProductFromCartProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ payload: DeleteProductFromCartProps }>(`cart/${cart_id}/remove`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro deleteProductFromCart:', error);
      throw error;
    }
  }

  async updateCartTable(cart_id: number, payload: UpdateCartTableProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ payload: UpdateCartTableProps }>(`cart/update/${cart_id}`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro updateCartTable:', error);
      throw error;
    }
  }

}
